import type {TAPIElementFieldNames} from '@/assets/core/assets/api/types';
import type {IAirflowUpdate} from '@/api/types/airflow';

import {airflowAPI} from '@/api/requesters/airflow';

const fieldNames: TAPIElementFieldNames<IAirflowUpdate> = {
  pageTitle: 'Airflow`s',
  drawerTitle: 'Airflow',

  url: 'Ссылка',
  name: 'Название',
  username: 'Имя пользователя',
  password: 'Пароль',
};

const useAirflowControllerHook = () => {
  const api = airflowAPI.clone();

  const validate = (form?: IAirflowUpdate) => {
    return !!form?.url && !!form.name && !!form.username && !!form.password;
  };

  const validateUpdate = (form?: IAirflowUpdate) => {
    return !!form?.url && !!form.name && !!form.username;
  };

  return {
    ...api,
    fieldNames,

    validate,
    validateUpdate,
  };
};

const airflowController = useAirflowControllerHook();

export default airflowController;
